import { ButtonLink } from "../components/ui/Button";
import { useSession } from "../store/session/SessionProvider";
import { homeFor } from "./table";
import type { ScreenRoute } from "./table";

/** 개발 자리표시 — 이후 스프린트 화면. 문구는 개발용이라 카탈로그 밖에 둔다. */
export function PlaceholderScreen({ route }: { route: ScreenRoute }) {
  const state = useSession();
  const home = state.status === "ready" ? homeFor(state.session.role) : "/launch";
  return (
    <section className="pf-pane">
      <h1 className="pf-h">
        {route.id} {route.title}
      </h1>
      <p className="pf-muted">
        자리표시 화면 · 라우트 <code>{route.path}</code> · Phase {route.phase}
      </p>
      <ButtonLink to={home} variant="ghost" icon="↩">
        입구로
      </ButtonLink>
    </section>
  );
}
